// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    height: 100%;
    /* border: 5px solid skyblue;  */
}

p {
  font-family: Arial, sans-serif;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.site-title {
  font-family: Arial, sans-serif;
  color: rgb(197, 193, 193);
  padding: 0px;
  margin: 0px;
  font-size: 20px;
  height: 16px;
  margin-left: 5px;
  width: 140px;
}

.disclaimer {
  position: absolute;
  color: grey;
  flex-wrap: wrap;
  /* width: 25%; */
  width: 100px;
  /* border: 5px solid black;   */
  margin-top: 10px;
  margin-left: 5px;
  font-size: 14px;
}

.container {
  position: absolute;
  overflow-y: scroll;
  font-family: Arial, sans-serif;
  height: 90%;
  /* margin-top: 10px; */
  /* margin-left: 30%; */
  margin-left: 110px;
  padding-top: 0px;
  margin-top: 20px;
  width: 260px;
  /* border: 5px solid blue; */
}

.company-info {
  text-align: left;
  /* font-weight: bold; */
  border-bottom: 0px solid grey;
  margin-bottom: 10px;
  box-shadow: 0 1px 1px -1px grey;
  width: 97%;
}

.company-title {
  overflow-wrap: break-word;
  color: chocolate;
  width: 90%;
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 20px;
  /* border: 2px solid gold; */
}

.wrapper-div {
  display: grid;
  /* border: 2px solid gold; */
}

.container-1 {
  width: 104px;
  margin-left: 5px;
  margin-bottom: 10px;
  /* width: 200px;
  margin-left: 20px;
  margin-bottom: 20px; */
  /* border: 2px solid gold; */
}


/* #number_of_years { */
.number_of_years {
  color: blue;
  /* font-size: 100px; */
  font-size: 40px;
  font-weight: bold;
  text-align: center;
  padding-bottom:0px;
  /* margin-top:0px; */
  margin-top:25px;
  margin-bottom:0px;
  /* border: 2px solid gold; */
}

.yrs {
  /* font-size: 50px; */
  font-size: 20px;
  font-weight: bold;
  text-align: left;
}

/* #number_of_years-caption { */
.number_of_years-caption {
  color: grey;
  /* font-size: 50px; */
  font-size: 14px;
  margin-top: 0px;
  padding-bottom: 0px;
  /* border: 2px solid gold; */
}


.container-2 {
  width: 104px;
  margin-left: 15px;
  margin-bottom: 10px;
  /* margin-left: 45px;
  margin-bottom: 20px; */
  /* border: 2px solid gold; */
}

/* #cumulative_growth_occurrence_rate { */
.cumulative_growth_occurrence_rate {
  color: blue;
  font-weight: bold;
  text-align: center;
  padding-bottom:0px;
  /* margin-top:0px; */
  margin-top:25px;
  margin-bottom:0px;
  width: 104px;
  font-size: 40px;
  /* border: 2px solid gold; */
}


/* #cumulative_growth_occurrence_rate-caption { */
.cumulative_growth_occurrence_rate-caption {
  color: grey;
  width: 104px;
  font-size: 14px;
  margin-top: 0px;
  /* border: 2px solid gold; */
}

.spacer-w-same-height-as-external-link-icon {
  width: 104px;
  height: 18px;
  margin-bottom: 2px;
}


.container-3 {
  /* margin-bottom: 20px; */
  width: 104px;
  height: 100px;
  margin-left: 5px;
  margin-bottom: 10px;
  /* background-color: aqua; */
  /* border: 2px solid gold; */
}


.container-4 {
  /* margin-bottom: 20px; */
  width: 104px;
  height: 85px;
  margin-left: 15px;
  margin-bottom: 10px;
  /* background-color: aqua; */
  /* border: 2px solid gold; */
  /* box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.08); */
}

.external-link-icon {
  width: 18px;
  height: 18px;
  margin-left: 4px;
  vertical-align: text-top;
  filter: none;
  opacity: 0.9;
}

.external-icon-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 2px;
}


/* .external-icon-wrapper {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 1;
} */


.chart {
  margin-bottom: 0px;
  width: 104px;
  height: 65px; 
  /* border: 2px solid gold; */
}

.chart-title {
  text-align: left;
  color: grey;
  font-size: 14px;
  /* margin-top: -2px; */
  margin-top: 0px;
  vertical-align: top;
  /* border: 2px solid gold; */
}


.container-5 {
  /* width: 200px; */
  width: 104px;
  margin-left: 5px;
  margin-bottom: 20px;
  /* border: 2px solid gold; */
}


/* #dividend_yield { */
.dividend_yield {
  color: blue;
  font-weight: bold;
  /* text-align: left; */
  text-align: center;
  font-size: 35px;
  padding-bottom:0px;
  margin-top:25px;
  margin-bottom:0px;
  /* border: 2px solid gold; */
}

/* #dividend_yield-caption { */
.dividend_yield-caption {
  color: grey;
  font-size: 14px;
  margin-top: 0px;
  /* border: 2px solid gold; */
}


/* Modal backdrop styles */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: rgba(0, 0, 0, 0.98); */
  background: transparent; /* 黒背景 → 透明に */
  z-index: 1000;
}

.modal-bg-video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.modal-dim {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: rgba(0, 0, 60, 0.85); */
  background: rgba(0, 0, 40, 0.8);
  z-index: 0;
}

.modal-container {
  position: relative; /* 背景より前に出す */
  max-width: 600px; /* Adjust this value to your preference */
  margin: auto;
  padding: 20px;
  /* background: white; */
  background: rgba(255, 255, 255, 0.96);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-wrap: break-word; /* Ensure text wraps within the container */
  z-index: 1;
  color: #333333;
}

/* Add to your CSS file */
.button-container {
  display: flex;
  justify-content: center; /* Center buttons horizontally */
  gap: 10px; /* Add some space between buttons */
}

.modal-greeting {
  font-size: 1em;       /* 少し小さく（デフォルトが1em） */
  font-weight: bold;
  line-height: 1.2;       /* 行間を詰める（デフォルトは1.4前後） */
  margin-bottom: 0.2em;   /* 下の余白も少なめに */
  color: #7a7878;
}

.modal-highlight {
  background-color: yellow;
  padding: 0.1em 0.2em;
  color: #7a7878;
}

/* General button styles */
.button {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  color: white;
  font-size: 16px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s ease;
}

/* Color variations */
.button-yes {
  background-color: #9acd32;;
  width: 150px; /* Adjust the width as needed */
}

.button-yes:hover {
  background-color: #0056b3;
}

.button-no {
  background-color: #cccccc;
  width: 150px; /* Adjust the width as needed */
}

.button-no:hover {
  background-color: #c82333;
}


@media (min-width: 268px) {

  .site-title {
    font-size: 20px;
    height: 16px;
    margin-left: 5px;
  }

  .disclaimer{
    margin-top: 10px;
    margin-left: 5px;
    font-size: 14px;
  }

  .container {
    margin-top: 20px;
    width: 260px;
  }

  .company-title {
    font-size: 20px;
  }

  .wrapper-div {
    /* width: 208px; */
    grid-template-columns: 104px 104px;
  }

  .container-1 {
    width: 104px;
    margin-left: 5px;
    margin-bottom: 10px;
  }

  /* #number_of_years { */
  .number_of_years {

    font-size: 40px;
  }

  .yrs {
    font-size: 20px;
  }

  /* #number_of_years-caption { */
  .number_of_years-caption {
    font-size: 14px;
    /* font-weight: 300; */
  }

  .container-2 {
    width: 104px;
    margin-left: 15px;
    margin-bottom: 10px;
  }

  /* #cumulative_growth_occurrence_rate { */
  .cumulative_growth_occurrence_rate {
    width: 104px;
    font-size: 40px;
  }

  /* #cumulative_growth_occurrence_rate-caption { */
  .cumulative_growth_occurrence_rate-caption {
    width: 104px;
    font-size: 14px;
  }

  .container-3 {
    width: 104px;
    height: 100px;
    margin-left: 5px;
    margin-bottom: 10px;
  }

  .container-4 {
    width: 104px;
    /* height: 100px; */
    height: 85px;
    margin-left: 15px;
    margin-bottom: 10px;
  }

  .chart {
    width: 104px;
    height: 65px; 
  }

  .chart-title {
    font-size: 14px;
    margin-top: -2px;
    vertical-align: top;
  }

  .container-5 {
    width: 104px;
    margin-left: 5px;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  /* #dividend_yield { */
  .dividend_yield {
    font-size: 35px;
    padding-bottom:0px;
    margin-top:25px;
    margin-bottom:0px;
  }

  /* #dividend_yield-caption { */
  .dividend_yield-caption {
    font-size: 14px;
    margin-top: 0px;
  }
}


@media (min-width: 600px) {
  .site-title {
    font-size: 20px;
    height: 20px;
    margin-left: 20px;
  }

  .disclaimer{
    font-size: 14px;
    width: 160px;
    margin-top: 10px;
    margin-left: 20px;
  }

  .container {
    width: 400px;
    margin-left: 200px;
  }

  .company-title {
    font-size: 20px;
  }

  .wrapper-div {
    /* width: 312px; */
    grid-template-columns: 104px 104px 104px;

  }

  .container-2 {
    margin-left: 30px;
  }

  .container-3 {
    margin-left: 60px;
  }

  .container-4 {
    margin-left: 5px;
  }

  .container-5 {
    margin-left: 30px;
    margin-top: 0px;
  }

  .number_of_years-caption {
    font-size: 14px;
  }

  .cumulative_growth_occurrence_rate-caption {
    font-size: 14px;
  }

  .chart-title {
    font-size: 14px;
  }

  /* #dividend_yield-caption { */
  .dividend_yield-caption {
    font-size: 14px;
  }

}


@media (min-width: 800px) {
  .site-title {
    font-size: 24px;
    height: 25px;
    margin-left: 70px;
    width: 200px;
  }

  .disclaimer{
    font-size: 16px;
    width: 160px;
    margin-top: 10px;
    margin-left: 70px;
  }

  .container {
    width: 530px;
    margin-left: 260px;
  }

  .company-title {
    font-size: 20px;
  }

  .wrapper-div {
    /* width: 416px; */
    grid-template-columns: 104px 104px 104px 104px;
  }

  .container-2 {
    margin-left: 30px;
  }

  .container-3 {
    margin-left: 60px;
  }

  .container-4 {
    margin-left: 90px;
  }

  .container-5 {
    margin-left: 5px;
  }

  .number_of_years-caption {
    font-size: 16px;
  }

  .cumulative_growth_occurrence_rate-caption {
    font-size: 16px;
  }

  .chart-title {
    font-size: 16px;
  }

  /* #dividend_yield-caption { */
  .dividend_yield-caption {
    font-size: 16px;
  }
}

@media (min-width: 1000px) {
  .site-title {
    font-size: 25px;
    height: 30px;
    margin-left: 100px;
    width: 250px;
  }

  .disclaimer{
    font-size: 16px;
    width: 180px;
    margin-top: 10px;
    margin-left: 100px;
  }

  .container {
    width: 700px;
    margin-left: 310px;
  }

  .company-title {
    font-size: 20px;
  }

  .wrapper-div {
    /* width: 520px; */
    grid-template-columns: 104px 104px 104px 104px 104px;
  }

  .container-2 {
    margin-left: 30px;
  }

  .container-3 {
    margin-left: 60px;
  }

  .container-4 {
    margin-left: 90px;
  }

  .container-5 {
    margin-left: 120px;
  }
}

@media (min-width: 1200px) {

  .disclaimer{
    margin-top: 10px;
    margin-left: 200px;
    font-size: 16px;
    width: 200px;
  }

  .container {
    width: 730px;
    margin-left: 450px;
  }

  .site-title {
    font-size: 30px;
    height: 35px;
    margin-left: 200px;
  }

  .wrapper-div {
    grid-template-columns: 104px 104px 104px 104px 104px;
  }

  .container-2 {
    margin-left: 30px;
  }

  .container-3 {
    margin-left: 60px;
  }

  .container-4 {
    margin-left: 90px;
  }

  .container-5 {
    margin-left: 120px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gCAAgC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB;;wBAEsB;EACtB,4BAA4B;AAC9B;;;AAGA,uBAAuB;AACvB;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;;AAGA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB;wBACsB;EACtB,4BAA4B;AAC9B;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;;AAGA,iDAAiD;AACjD;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,4BAA4B;AAC9B;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;;AAGA;;;;;GAKG;;;AAGH;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;;AAGA,sBAAsB;AACtB;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;;AAGA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB,EAAE,cAAc;EACvC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,kBAAkB,EAAE,aAAa;EACjC,gBAAgB,EAAE,yCAAyC;EAC3D,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB,EAAE,2CAA2C;EACtE,UAAU;EACV,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB,EAAE,gCAAgC;EACzD,SAAS,EAAE,mCAAmC;AAChD;;AAEA;EACE,cAAc,QAAQ,qBAAqB;EAC3C,iBAAiB;EACjB,gBAAgB,QAAQ,wBAAwB;EAChD,oBAAoB,IAAI,cAAc;EACtC,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,sCAAsC;AACxC;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,YAAY,EAAE,+BAA+B;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY,EAAE,+BAA+B;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;;EAEE;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,uBAAuB;EACvB;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,yCAAyC;EACzC;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA,iDAAiD;EACjD;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA,8BAA8B;EAC9B;IACE,eAAe;IACf,eAAe;EACjB;AACF;;;AAGA;EACE;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,wCAAwC;;EAE1C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,8BAA8B;EAC9B;IACE,eAAe;EACjB;;AAEF;;;AAGA;EACE;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,8CAA8C;EAChD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,8BAA8B;EAC9B;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,oDAAoD;EACtD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".App {\n    height: 100%;\n    /* border: 5px solid skyblue;  */\n}\n\np {\n  font-family: Arial, sans-serif;\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.site-title {\n  font-family: Arial, sans-serif;\n  color: rgb(197, 193, 193);\n  padding: 0px;\n  margin: 0px;\n  font-size: 20px;\n  height: 16px;\n  margin-left: 5px;\n  width: 140px;\n}\n\n.disclaimer {\n  position: absolute;\n  color: grey;\n  flex-wrap: wrap;\n  /* width: 25%; */\n  width: 100px;\n  /* border: 5px solid black;   */\n  margin-top: 10px;\n  margin-left: 5px;\n  font-size: 14px;\n}\n\n.container {\n  position: absolute;\n  overflow-y: scroll;\n  font-family: Arial, sans-serif;\n  height: 90%;\n  /* margin-top: 10px; */\n  /* margin-left: 30%; */\n  margin-left: 110px;\n  padding-top: 0px;\n  margin-top: 20px;\n  width: 260px;\n  /* border: 5px solid blue; */\n}\n\n.company-info {\n  text-align: left;\n  /* font-weight: bold; */\n  border-bottom: 0px solid grey;\n  margin-bottom: 10px;\n  box-shadow: 0 1px 1px -1px grey;\n  width: 97%;\n}\n\n.company-title {\n  overflow-wrap: break-word;\n  color: chocolate;\n  width: 90%;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  font-weight: bold;\n  font-size: 20px;\n  /* border: 2px solid gold; */\n}\n\n.wrapper-div {\n  display: grid;\n  /* border: 2px solid gold; */\n}\n\n.container-1 {\n  width: 104px;\n  margin-left: 5px;\n  margin-bottom: 10px;\n  /* width: 200px;\n  margin-left: 20px;\n  margin-bottom: 20px; */\n  /* border: 2px solid gold; */\n}\n\n\n/* #number_of_years { */\n.number_of_years {\n  color: blue;\n  /* font-size: 100px; */\n  font-size: 40px;\n  font-weight: bold;\n  text-align: center;\n  padding-bottom:0px;\n  /* margin-top:0px; */\n  margin-top:25px;\n  margin-bottom:0px;\n  /* border: 2px solid gold; */\n}\n\n.yrs {\n  /* font-size: 50px; */\n  font-size: 20px;\n  font-weight: bold;\n  text-align: left;\n}\n\n/* #number_of_years-caption { */\n.number_of_years-caption {\n  color: grey;\n  /* font-size: 50px; */\n  font-size: 14px;\n  margin-top: 0px;\n  padding-bottom: 0px;\n  /* border: 2px solid gold; */\n}\n\n\n.container-2 {\n  width: 104px;\n  margin-left: 15px;\n  margin-bottom: 10px;\n  /* margin-left: 45px;\n  margin-bottom: 20px; */\n  /* border: 2px solid gold; */\n}\n\n/* #cumulative_growth_occurrence_rate { */\n.cumulative_growth_occurrence_rate {\n  color: blue;\n  font-weight: bold;\n  text-align: center;\n  padding-bottom:0px;\n  /* margin-top:0px; */\n  margin-top:25px;\n  margin-bottom:0px;\n  width: 104px;\n  font-size: 40px;\n  /* border: 2px solid gold; */\n}\n\n\n/* #cumulative_growth_occurrence_rate-caption { */\n.cumulative_growth_occurrence_rate-caption {\n  color: grey;\n  width: 104px;\n  font-size: 14px;\n  margin-top: 0px;\n  /* border: 2px solid gold; */\n}\n\n.spacer-w-same-height-as-external-link-icon {\n  width: 104px;\n  height: 18px;\n  margin-bottom: 2px;\n}\n\n\n.container-3 {\n  /* margin-bottom: 20px; */\n  width: 104px;\n  height: 100px;\n  margin-left: 5px;\n  margin-bottom: 10px;\n  /* background-color: aqua; */\n  /* border: 2px solid gold; */\n}\n\n\n.container-4 {\n  /* margin-bottom: 20px; */\n  width: 104px;\n  height: 85px;\n  margin-left: 15px;\n  margin-bottom: 10px;\n  /* background-color: aqua; */\n  /* border: 2px solid gold; */\n  /* box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.08); */\n}\n\n.external-link-icon {\n  width: 18px;\n  height: 18px;\n  margin-left: 4px;\n  vertical-align: text-top;\n  filter: none;\n  opacity: 0.9;\n}\n\n.external-icon-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 2px;\n}\n\n\n/* .external-icon-wrapper {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  z-index: 1;\n} */\n\n\n.chart {\n  margin-bottom: 0px;\n  width: 104px;\n  height: 65px; \n  /* border: 2px solid gold; */\n}\n\n.chart-title {\n  text-align: left;\n  color: grey;\n  font-size: 14px;\n  /* margin-top: -2px; */\n  margin-top: 0px;\n  vertical-align: top;\n  /* border: 2px solid gold; */\n}\n\n\n.container-5 {\n  /* width: 200px; */\n  width: 104px;\n  margin-left: 5px;\n  margin-bottom: 20px;\n  /* border: 2px solid gold; */\n}\n\n\n/* #dividend_yield { */\n.dividend_yield {\n  color: blue;\n  font-weight: bold;\n  /* text-align: left; */\n  text-align: center;\n  font-size: 35px;\n  padding-bottom:0px;\n  margin-top:25px;\n  margin-bottom:0px;\n  /* border: 2px solid gold; */\n}\n\n/* #dividend_yield-caption { */\n.dividend_yield-caption {\n  color: grey;\n  font-size: 14px;\n  margin-top: 0px;\n  /* border: 2px solid gold; */\n}\n\n\n/* Modal backdrop styles */\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* background-color: rgba(0, 0, 0, 0.98); */\n  background: transparent; /* 黒背景 → 透明に */\n  z-index: 1000;\n}\n\n.modal-bg-video {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 0;\n}\n\n.modal-dim {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  /* background: rgba(0, 0, 60, 0.85); */\n  background: rgba(0, 0, 40, 0.8);\n  z-index: 0;\n}\n\n.modal-container {\n  position: relative; /* 背景より前に出す */\n  max-width: 600px; /* Adjust this value to your preference */\n  margin: auto;\n  padding: 20px;\n  /* background: white; */\n  background: rgba(255, 255, 255, 0.96);\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow-wrap: break-word; /* Ensure text wraps within the container */\n  z-index: 1;\n  color: #333333;\n}\n\n/* Add to your CSS file */\n.button-container {\n  display: flex;\n  justify-content: center; /* Center buttons horizontally */\n  gap: 10px; /* Add some space between buttons */\n}\n\n.modal-greeting {\n  font-size: 1em;       /* 少し小さく（デフォルトが1em） */\n  font-weight: bold;\n  line-height: 1.2;       /* 行間を詰める（デフォルトは1.4前後） */\n  margin-bottom: 0.2em;   /* 下の余白も少なめに */\n  color: #7a7878;\n}\n\n.modal-highlight {\n  background-color: yellow;\n  padding: 0.1em 0.2em;\n  color: #7a7878;\n}\n\n/* General button styles */\n.button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n  outline: none;\n  transition: background-color 0.3s ease;\n}\n\n/* Color variations */\n.button-yes {\n  background-color: #9acd32;;\n  width: 150px; /* Adjust the width as needed */\n}\n\n.button-yes:hover {\n  background-color: #0056b3;\n}\n\n.button-no {\n  background-color: #cccccc;\n  width: 150px; /* Adjust the width as needed */\n}\n\n.button-no:hover {\n  background-color: #c82333;\n}\n\n\n@media (min-width: 268px) {\n\n  .site-title {\n    font-size: 20px;\n    height: 16px;\n    margin-left: 5px;\n  }\n\n  .disclaimer{\n    margin-top: 10px;\n    margin-left: 5px;\n    font-size: 14px;\n  }\n\n  .container {\n    margin-top: 20px;\n    width: 260px;\n  }\n\n  .company-title {\n    font-size: 20px;\n  }\n\n  .wrapper-div {\n    /* width: 208px; */\n    grid-template-columns: 104px 104px;\n  }\n\n  .container-1 {\n    width: 104px;\n    margin-left: 5px;\n    margin-bottom: 10px;\n  }\n\n  /* #number_of_years { */\n  .number_of_years {\n\n    font-size: 40px;\n  }\n\n  .yrs {\n    font-size: 20px;\n  }\n\n  /* #number_of_years-caption { */\n  .number_of_years-caption {\n    font-size: 14px;\n    /* font-weight: 300; */\n  }\n\n  .container-2 {\n    width: 104px;\n    margin-left: 15px;\n    margin-bottom: 10px;\n  }\n\n  /* #cumulative_growth_occurrence_rate { */\n  .cumulative_growth_occurrence_rate {\n    width: 104px;\n    font-size: 40px;\n  }\n\n  /* #cumulative_growth_occurrence_rate-caption { */\n  .cumulative_growth_occurrence_rate-caption {\n    width: 104px;\n    font-size: 14px;\n  }\n\n  .container-3 {\n    width: 104px;\n    height: 100px;\n    margin-left: 5px;\n    margin-bottom: 10px;\n  }\n\n  .container-4 {\n    width: 104px;\n    /* height: 100px; */\n    height: 85px;\n    margin-left: 15px;\n    margin-bottom: 10px;\n  }\n\n  .chart {\n    width: 104px;\n    height: 65px; \n  }\n\n  .chart-title {\n    font-size: 14px;\n    margin-top: -2px;\n    vertical-align: top;\n  }\n\n  .container-5 {\n    width: 104px;\n    margin-left: 5px;\n    margin-bottom: 20px;\n    margin-top: 20px;\n  }\n\n  /* #dividend_yield { */\n  .dividend_yield {\n    font-size: 35px;\n    padding-bottom:0px;\n    margin-top:25px;\n    margin-bottom:0px;\n  }\n\n  /* #dividend_yield-caption { */\n  .dividend_yield-caption {\n    font-size: 14px;\n    margin-top: 0px;\n  }\n}\n\n\n@media (min-width: 600px) {\n  .site-title {\n    font-size: 20px;\n    height: 20px;\n    margin-left: 20px;\n  }\n\n  .disclaimer{\n    font-size: 14px;\n    width: 160px;\n    margin-top: 10px;\n    margin-left: 20px;\n  }\n\n  .container {\n    width: 400px;\n    margin-left: 200px;\n  }\n\n  .company-title {\n    font-size: 20px;\n  }\n\n  .wrapper-div {\n    /* width: 312px; */\n    grid-template-columns: 104px 104px 104px;\n\n  }\n\n  .container-2 {\n    margin-left: 30px;\n  }\n\n  .container-3 {\n    margin-left: 60px;\n  }\n\n  .container-4 {\n    margin-left: 5px;\n  }\n\n  .container-5 {\n    margin-left: 30px;\n    margin-top: 0px;\n  }\n\n  .number_of_years-caption {\n    font-size: 14px;\n  }\n\n  .cumulative_growth_occurrence_rate-caption {\n    font-size: 14px;\n  }\n\n  .chart-title {\n    font-size: 14px;\n  }\n\n  /* #dividend_yield-caption { */\n  .dividend_yield-caption {\n    font-size: 14px;\n  }\n\n}\n\n\n@media (min-width: 800px) {\n  .site-title {\n    font-size: 24px;\n    height: 25px;\n    margin-left: 70px;\n    width: 200px;\n  }\n\n  .disclaimer{\n    font-size: 16px;\n    width: 160px;\n    margin-top: 10px;\n    margin-left: 70px;\n  }\n\n  .container {\n    width: 530px;\n    margin-left: 260px;\n  }\n\n  .company-title {\n    font-size: 20px;\n  }\n\n  .wrapper-div {\n    /* width: 416px; */\n    grid-template-columns: 104px 104px 104px 104px;\n  }\n\n  .container-2 {\n    margin-left: 30px;\n  }\n\n  .container-3 {\n    margin-left: 60px;\n  }\n\n  .container-4 {\n    margin-left: 90px;\n  }\n\n  .container-5 {\n    margin-left: 5px;\n  }\n\n  .number_of_years-caption {\n    font-size: 16px;\n  }\n\n  .cumulative_growth_occurrence_rate-caption {\n    font-size: 16px;\n  }\n\n  .chart-title {\n    font-size: 16px;\n  }\n\n  /* #dividend_yield-caption { */\n  .dividend_yield-caption {\n    font-size: 16px;\n  }\n}\n\n@media (min-width: 1000px) {\n  .site-title {\n    font-size: 25px;\n    height: 30px;\n    margin-left: 100px;\n    width: 250px;\n  }\n\n  .disclaimer{\n    font-size: 16px;\n    width: 180px;\n    margin-top: 10px;\n    margin-left: 100px;\n  }\n\n  .container {\n    width: 700px;\n    margin-left: 310px;\n  }\n\n  .company-title {\n    font-size: 20px;\n  }\n\n  .wrapper-div {\n    /* width: 520px; */\n    grid-template-columns: 104px 104px 104px 104px 104px;\n  }\n\n  .container-2 {\n    margin-left: 30px;\n  }\n\n  .container-3 {\n    margin-left: 60px;\n  }\n\n  .container-4 {\n    margin-left: 90px;\n  }\n\n  .container-5 {\n    margin-left: 120px;\n  }\n}\n\n@media (min-width: 1200px) {\n\n  .disclaimer{\n    margin-top: 10px;\n    margin-left: 200px;\n    font-size: 16px;\n    width: 200px;\n  }\n\n  .container {\n    width: 730px;\n    margin-left: 450px;\n  }\n\n  .site-title {\n    font-size: 30px;\n    height: 35px;\n    margin-left: 200px;\n  }\n\n  .wrapper-div {\n    grid-template-columns: 104px 104px 104px 104px 104px;\n  }\n\n  .container-2 {\n    margin-left: 30px;\n  }\n\n  .container-3 {\n    margin-left: 60px;\n  }\n\n  .container-4 {\n    margin-left: 90px;\n  }\n\n  .container-5 {\n    margin-left: 120px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
